import { render, staticRenderFns } from "./addWinner.vue?vue&type=template&id=d0d80d68&scoped=true&"
import script from "./addWinner.vue?vue&type=script&lang=js&"
export * from "./addWinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d80d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0d80d68')) {
      api.createRecord('d0d80d68', component.options)
    } else {
      api.reload('d0d80d68', component.options)
    }
    module.hot.accept("./addWinner.vue?vue&type=template&id=d0d80d68&scoped=true&", function () {
      api.rerender('d0d80d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/divisionAllController/component/addWinner.vue"
export default component.exports